import * as React from "react";
import PropTypes from "prop-types";
import ItemList from "nx-components/ItemList";
import RichLabel from "nx-components/RichLabel";
import prefixStyles from "nx-components/utils/prefixStyles";

const styles = {
  wrapper: prefixStyles({
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  title: {
    fontWeight: "bold",
    color: "black",
    padding: "1em 1em 0 1em",
  },
  modes: {
    overflowX: "hidden",
    overflowY: "auto",
  },
  mode: {
    padding: "1em",
    width: "100%",
  },
};

export default class DumbModeList extends React.Component {
  static propTypes = {
    modes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        name: PropTypes.string.isRequired,
        icon: PropTypes.node,
        isSelected: PropTypes.bool,
      })
    ),
    onModeSelected: PropTypes.func, // (modeId: string) => void
  };

  render() {
    const { modes, onModeSelected } = this.props;

    return (
      <div style={styles.wrapper}>
        <div style={styles.title}>Choose a Mode</div>
        <div style={styles.modes}>
          <ItemList
            id="modes"
            showDividers
            items={modes.map(({ id, name, icon, isSelected }) => ({
              id,
              selected: isSelected,
              children: <RichLabel icon={icon} label={name} />,
              childWrapperStyle: styles.mode,
              onTap: () => {
                if (onModeSelected != null) {
                  onModeSelected(id);
                }
              },
            }))}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/ModeSelector/DumbModeList.jsx